<div class="mx-3">
    <linces-page-with-tabs [icon]="icon" [tabs]="tabs"></linces-page-with-tabs>
</div>